import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TransactionTypesPage = () => {
  const [transactionTypes, setTransactionTypes] = useState([]);
  const [newTransactionType, setNewTransactionType] = useState({
    name: '',
    description: '',
  });
  const [editingTransactionType, setEditingTransactionType] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get('http://localhost:5001/api/transaction-types');
        setTransactionTypes(res.data);
      } catch (error) {
        console.error('Error fetching transaction types:', error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTransactionType((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddTransactionType = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('http://localhost:5001/api/transaction-types', newTransactionType);
      setTransactionTypes((prev) => [...prev, res.data]);
      setNewTransactionType({ name: '', description: '' });
    } catch (error) {
      console.error('Error adding transaction type:', error);
    }
  };

  const handleEditTransactionType = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.put(`http://localhost:5001/api/transaction-types/${editingTransactionType._id}`, editingTransactionType);
      setTransactionTypes((prev) =>
        prev.map((type) => (type._id === editingTransactionType._id ? res.data : type))
      );
      setEditingTransactionType(null);
    } catch (error) {
      console.error('Error editing transaction type:', error);
    }
  };

  const handleDeleteTransactionType = async (id) => {
    try {
      await axios.delete(`http://localhost:5001/api/transaction-types/${id}`);
      setTransactionTypes((prev) => prev.filter((type) => type._id !== id));
    } catch (error) {
      console.error('Error deleting transaction type:', error);
    }
  };

  return (
    <div>
      <h1>Transaction Types</h1>

      <form onSubmit={editingTransactionType ? handleEditTransactionType : handleAddTransactionType}>
        <input
          type="text"
          name="name"
          value={newTransactionType.name}
          onChange={handleInputChange}
          placeholder="Name"
          required
        />
        <input
          type="text"
          name="description"
          value={newTransactionType.description}
          onChange={handleInputChange}
          placeholder="Description"
        />
        <button type="submit">
          {editingTransactionType ? 'Update' : 'Add'}
        </button>
      </form>

      <ul>
        {transactionTypes.map((type) => (
          <li key={type._id}>
            {type.name} - {type.description}
            <button onClick={() => setEditingTransactionType(type)}>Edit</button>
            <button onClick={() => handleDeleteTransactionType(type._id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TransactionTypesPage;
